var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-product-listing',{key:_vm.$route.fullPath,attrs:{"props-data":_vm.uiProductListingPropsData}})}
var staticRenderFns = []

export { render, staticRenderFns }